import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ManageDashboardRoutingModule } from '@flyfreely-portal-ui/manage-dashboard';
import { MissionViewRoutingModule } from '@flyfreely-portal-ui/mission-view';
import { OutstandingTasksRoutingModule } from '@flyfreely-portal-ui/outstanding-tasks';
import { ReportingRoutingModule } from '@flyfreely-portal-ui/reporting';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        RouterModule.forChild([
            {
                path: 'home',
                loadChildren: () => ManageDashboardRoutingModule,
                data: {
                    enhancedHelpComponentIdentifier: 'manage-dashboard',
                    routeNodeType: 'dashboard'
                }
            },
            {
                path: 'missions',
                loadChildren: () => MissionViewRoutingModule,
                data: {
                    enhancedHelpComponentIdentifier: 'missions-dashboard',
                    routeNodeType: 'dashboard'
                }
            },
            {
                path: 'reporting',
                loadChildren: () => ReportingRoutingModule,
                data: {
                    enhancedHelpComponentIdentifier: 'reporting-dashboard',
                    routeNodeType: 'dashboard'
                }
            },
            {
                path: 'tasks',
                loadChildren: () => OutstandingTasksRoutingModule,
                data: {
                    enhancedHelpComponentIdentifier: 'tasks-dashboard',
                    routeNodeType: 'dashboard'
                }
            }
        ])
    ],
    exports: [RouterModule]
})
export class WorkspaceRoutingModule {}
